import { render } from "./HealthIcon.vue?vue&type=template&id=b234d638"
import script from "./HealthIcon.vue?vue&type=script&lang=ts"
export * from "./HealthIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script